import React from 'react';


const Header = () => {
    return (
        <div className={'header'}>
            <h1>Lets do Todo</h1>

        </div>
    );
};

export default Header;
